import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { TextPriority } from 'wix-ui-tpa/dist/src/components/Text/types';
import { classes } from './ExpandedCalendarName.st.css';
import CalendarIcon from './CalendarIcon';
import { useTranslation } from 'react-i18next';
import { DEMO_CALENDARS_IDS } from '../../../constants';
var ExpandedCalendarName = function (_a) {
    var calendarName = _a.calendarName, calendarId = _a.calendarId;
    var t = useTranslation()[0];
    var clendarNameToDisplay = calendarName;
    if (DEMO_CALENDARS_IDS.includes(calendarId)) {
        clendarNameToDisplay = t(calendarName);
    }
    return (React.createElement(React.Fragment, null, calendarName ? (React.createElement("div", { className: classes.CalendarNameWrapper },
        React.createElement(CalendarIcon, null),
        React.createElement(Text, { className: classes.CalendarName, key: "primary", priority: TextPriority.primary }, clendarNameToDisplay))) : null));
};
export default ExpandedCalendarName;
//# sourceMappingURL=ExpandedCalendarName.js.map